// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__br2UM","col":"styles_col__8UiiP"};